import React from 'react'
import SALink from 'components/SALink'
import { USPList, CONTACT_US_LINK, ART_ADVISORY_LINK } from '../helpers/constants'

import styles from './styles/uspSection.module.scss'

const USPSection = () => {
  return (
    <div className={styles.uspSectionContainer} sa-type='usp-section'>
      <div className={styles.uspItemsContainer}>
        {USPList.map((item, index) => (
          <div key={`usps-${index}`} className={styles.uspItemsColumn}>
            <div className={styles.uspItemsIcon}>{item.image}</div>
            <div className={styles.uspItemsTitle}>
              <h6 className='defaultTypographyH6'>{item.title}</h6>
            </div>
            <div className={styles.uspItemsDescription}>
              <p className='defaultTypographyXSmall'>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.uspNeedMoreHelp}>
        <h4 className='defaultTypographyH4'>Need More Help?</h4>
        <div className={styles.uspNeedMoreHelpButtonsContainer}>
          <div className={styles.uspNeedMoreHelpButtonsBox}>
            <SALink
              href={ART_ADVISORY_LINK}
              title='art advisory'
              target='_blank'
              rel='noopener noreferrer'
            >
              <p className='defaultTypographyCtaSmall'>Enjoy Complimentary Art Advisory</p>
            </SALink>
          </div>
          <div className={styles.uspNeedMoreHelpButtonsBox}>
            <SALink
              href={CONTACT_US_LINK}
              title='support'
              target='_blank'
              rel='noopener noreferrer'
            >
              <p className='defaultTypographyCtaSmall'>Contact Customer Support</p>
            </SALink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default USPSection
